import React from "react";

export interface IV2RoadmapProps {
	pcode: string;
	history: any; //Usually game[pcode].roadmap.big_road, taken from fetchGameHistory()
	type: string;
	historyBlink: boolean; //Roadmap icon blink

	lobbyMobile?: boolean;
	showGroup?: boolean;
	small?: boolean;
	mobile?: boolean;
	showLobbyGameGroup?: boolean;

	enlarged?: boolean;
	expanded?: boolean;
}

export class IV2RoadmapClass extends React.Component<IV2RoadmapProps> {
	totalColumns: number;

	alternatingStyle: string;
	firstDisplayedCol: number;
	firstRoadmapDisplayedCol: number;

	currentRow: number;
	currentCol: number;
	currentType: string;
	currentDisplayRow: number;
	currentDisplayCol: number;

	simpleBigRoad: string[];
	simpleBigRoadPairs: string[];
	bigRoadSequence: number[][];
	roadmapTypes: string[][];

	roadmapDisplay: JSX.Element[][];
	roadmapPairsDisplay: JSX.Element[][][];
	roadmapTiesDisplay: JSX.Element[][];
}